import React from 'react';

export default function UserCommunicationRetentionPage() {
    return <div>UserCommunicationRetentionPage</div>;
}
